import { BusinessSubscription } from "lens-platform-sdk";
import { getPlanData, PlanCode } from "./plans";

export const getSubscriptionPlanMetaData = (subscription?: BusinessSubscription, lensTeamLicenseFlag?: boolean) => {
  if (subscription) {
    return getPlanData(subscription.planCode as PlanCode);
  }

  if (lensTeamLicenseFlag) {
    return getPlanData("team" as PlanCode);
  }

  return null;
};
